import {SelectionModel} from '@angular/cdk/collections';
import {DisabledObj} from '../../../../generated/generated-core.model';
import {RESTRICTED} from '../../../shared/services/mx-permission.service';
import {MxButtonModel} from '../../mx-button/components/mx-button.model';
import {GridCollectionService} from './mx-grid-collection.service';
import {Observable} from 'rxjs';
import {DefaultGridButtons} from './mx-grid-enums';


export type MxGridButtonHiddenFn = (selection?: SelectionModel<any>) => boolean;

export type MxGridButtonTooltipFn = (selection?: SelectionModel<any>) => string;

export type MxGridButtonIconFn = (selection?: SelectionModel<any>) => string;

export type MxGridButtonDisableFn = (selection?: SelectionModel<any>) => false | string | Observable<DisabledObj>;

export type MxGridButtonClickHandlerFn = (selection?: SelectionModel<any>, collectionService?: GridCollectionService) => void;


export class MxGridButtonModel {

    // BoButtonModel properties
    public label?: string | (() => string);
    public name?: string;
    public className?: string;
    public color?: string;

    public permission?: string = 'all';

    public order?: number;

    // BoButtonModel changed properties
    public hidden?: MxGridButtonHiddenFn | boolean = false;
    public disabled?: MxGridButtonDisableFn | string | boolean = false;
    public icon?: MxGridButtonIconFn | string;
    public tooltip?: MxGridButtonTooltipFn | string;
    public clickHandler?: MxGridButtonClickHandlerFn;
}

export class MxGridButtonsConfig {
    private _map: Map<string, MxGridButtonModel>;

    public static multiConfig(keys: string[], value: MxGridButtonModel): MxGridButtonsConfig {
        const result = new MxGridButtonsConfig(keys.map(val => [val, value] as [string, MxGridButtonModel]));
        return result;
    }

    public static hideDefault (showFilter: boolean = false): MxGridButtonsConfig {
        const result = MxGridButtonsConfig.multiConfig(Object.keys(DefaultGridButtons)
            .filter(value => !(value === DefaultGridButtons.filter && showFilter))
            .map(key => DefaultGridButtons[key]), {hidden: true, permission: RESTRICTED});
        return result;
    }

    public static showButtons(buttons: Array<DefaultGridButtons>): MxGridButtonsConfig {
        const result = MxGridButtonsConfig.multiConfig(buttons
            .map(key => DefaultGridButtons[key]), {hidden: false, permission: 'all'});
        return result;
    }

    constructor(entries?: ReadonlyArray<[string, MxGridButtonModel]>) {
        this._map = new Map<string, MxGridButtonModel>(entries);
    }

    get = (key: string) => this._map.get(key);
    set = (key: string, value: MxGridButtonModel) => this._map.set(key, value);
    setMultiple (buttons: MxGridButtonsConfig): MxGridButtonsConfig {
        buttons.forEach((value: MxGridButtonModel, key: string) => {
            this._map.set(key, value);
        });
        return this;
    }
    values = () => this._map.values();
    forEach = (callback: (value: MxGridButtonModel, key: string, map: Map<string, MxGridButtonModel>) => void, thisArg?: any) =>
        this._map.forEach(callback, thisArg)
    getArray(): Array<MxGridButtonModel> {return Array.from(this._map.values()); }

    sort(): this {
        this._map = new Map<string, MxGridButtonModel>(Array.from(this._map)
            .sort((a, b) => {
                if (a[1].order === undefined) {
                    return 1;
                } else if (b[1].order === undefined) {
                    return -1;
                } else {
                    return a[1].order - b[1].order;
                }
            }));
        return this;
    }
}
